__turbopack_context__.v({
  "emailMessage": "mIT5Ka_emailMessage",
  "returnButton": "mIT5Ka_returnButton",
  "returnMessage": "mIT5Ka_returnMessage",
});
